import { useAtom } from "jotai";
import { ProjectNameAtom } from "./atoms";
import * as React from "react";
import * as strings from "./strings";
import { useNav } from "./useNav";

const {
  back_string,
  next_string,
  step1_intro,
  step1_projectname_label,
  step1_title,
} = strings;

export function Step1() {
  const { prev, next } = useNav();
  const [projectName, setProjectName] = useAtom(ProjectNameAtom);

  return (
    <>
      <div className="atc-step-header">
        <p className="at-tagline">Step 1 / 4</p>
        <h2 className="at-title">{step1_title}</h2>
        <div
          className="at-text"
          dangerouslySetInnerHTML={{ __html: step1_intro }}
        />
      </div>

      <div className="atc-row">
        <div className="atc-label">{step1_projectname_label}</div>
        <input
          type="text"
          className="at-input"
          value={projectName}
          onChange={e => setProjectName(e.target.value)}
        />
      </div>
      <div className="atc-button-group atc-button-group--border-top">
        <button className="button white" onClick={prev}>
          {back_string}
        </button>
        <button className="button red" onClick={next}>
          {next_string}
        </button>
      </div>
    </>
  );
}
